export enum EDocumentType {
	DEGREE = 'degree',
	CERTIFICATE = 'certificate'
}
export const CTipoDocumento: Record<EDocumentType, string> = {
	[EDocumentType.DEGREE]: 'TÍTULO',
	[EDocumentType.CERTIFICATE]: 'CERTIFICADO'
}

export enum EAuthorizationType {
	RVOE_FEDERAL = 1,
	RVOE_ESTATAL = 2,
	AUTORIZACION_FEDERAL = 3,
	AUTORIZACION_ESTATAL = 4,
	ACTA_DE_SESION = 5,
	ACUERDO_DE_INCORPORACION = 6,
	ACUERDO_SECRETARIAL_SEP = 7,
	DECRETO_DE_CREACION = 8,
	OTRO = 9
}

export const NOMBRE_AUTORIZACION: Record<EAuthorizationType, string> = {
	[EAuthorizationType.RVOE_FEDERAL]: 'RVOE FEDERAL',
	[EAuthorizationType.RVOE_ESTATAL]: 'RVOE ESTATAL',
	[EAuthorizationType.AUTORIZACION_FEDERAL]: 'AUTORIZACIÓN FEDERAL',
	[EAuthorizationType.AUTORIZACION_ESTATAL]: 'AUTORIZACIÓN ESTATAL',
	[EAuthorizationType.ACTA_DE_SESION]: 'ACTA DE SESIÓN',
	[EAuthorizationType.ACUERDO_DE_INCORPORACION]: 'ACUERDO DE INCORPORACIÓN',
	[EAuthorizationType.ACUERDO_SECRETARIAL_SEP]: 'ACUERDO SECRETARIAL SEP',
	[EAuthorizationType.DECRETO_DE_CREACION]: 'DECRETO DE CREACIÓN',
	[EAuthorizationType.OTRO]: 'OTRO'
}

export enum EGraduationMode {
	POR_TESIS = '1',
	POR_PROMEDIO = '2',
	POR_ESTUDIOS_POSGRADO = '3',
	POR_EXPERIENCIA_LABORAL = '4',
	POR_CENEVAL = '5',
	OTRO = '6'
}

export const NOMBRE_GRADUATION_MODE: Record<EGraduationMode, string> = {
	[EGraduationMode.POR_TESIS]: 'POR TESIS',
	[EGraduationMode.POR_PROMEDIO]: 'POR PROMEDIO',
	[EGraduationMode.POR_ESTUDIOS_POSGRADO]: 'POR ESTUDIOS DE POSGRADOS',
	[EGraduationMode.POR_EXPERIENCIA_LABORAL]: 'POR EXPERIENCIA LABORAL',
	[EGraduationMode.POR_CENEVAL]: 'POR CENEVAL',
	[EGraduationMode.OTRO]: 'OTRO'
}
export const MODALIDAD_TITULACION: Record<EGraduationMode, { modalidad: string; tipo: string }> = {
	[EGraduationMode.POR_TESIS]: {
		modalidad: 'POR TESIS',
		tipo: 'ACTA DE EXAMEN'
	},
	[EGraduationMode.POR_PROMEDIO]: {
		modalidad: 'POR PROMEDIO',
		tipo: 'CONSTANCIA DE EXCENSIÓN'
	},
	[EGraduationMode.POR_ESTUDIOS_POSGRADO]: {
		modalidad: 'POR ESTUDIOS DE POSGRADOS',
		tipo: 'CONSTANCIA DE EXCENSIÓN'
	},
	[EGraduationMode.POR_EXPERIENCIA_LABORAL]: {
		modalidad: 'POR EXPERIENCIA LABORAL',
		tipo: 'CONSTANCIA DE EXCENSIÓN'
	},
	[EGraduationMode.POR_CENEVAL]: {
		modalidad: 'POR CENEVAL',
		tipo: 'CONSTANCIA DE EXCENSIÓN'
	},
	[EGraduationMode.OTRO]: {
		modalidad: 'OTRO',
		tipo: 'CONSTANCIA DE EXCENSIÓN'
	}
}

export enum EStudyLevel {
	BACHELOR = 'LICENCIATURA',
	MASTER = 'MAESTRÍA'
}

export enum EDocumentStatus {
	PENDING = 'PENDING',
	APPROVED = 'APPROVED',
	REJECTED = 'REJECTED'
}
export const CEstadoDocumento: Record<EDocumentStatus, string> = {
	[EDocumentStatus.PENDING]: 'PENDIENTE',
	[EDocumentStatus.APPROVED]: 'APROBADO',
	[EDocumentStatus.REJECTED]: 'RECHAZADO'
}

export enum EGender {
	MALE = '251',
	FEMALE = '250'
}

export const CGender: Record<EGender, string> = {
	[EGender.MALE]: 'HOMBRE',
	[EGender.FEMALE]: 'MUJER'
}
export const CGenderType: Record<EGender, string> = {
	[EGender.MALE]: 'H',
	[EGender.FEMALE]: 'M'
}

export enum EPeriodType {
	SEMESTRE = 91,
	BIMESTRE = 92,
	CUATRIMESTRE = 93,
	TETRAMESTRE = 94,
	TRIMESTRE = 260,
	MODULAR = 261,
	ANUAL = 262
}
export const CPeriodType: { [key in EPeriodType]: string } = {
	[EPeriodType.SEMESTRE]: 'Semestre',
	[EPeriodType.BIMESTRE]: 'Bimestre',
	[EPeriodType.CUATRIMESTRE]: 'Cuatrimestre',
	[EPeriodType.TETRAMESTRE]: 'Tetramestre',
	[EPeriodType.TRIMESTRE]: 'Trimestre',
	[EPeriodType.MODULAR]: 'Modular',
	[EPeriodType.ANUAL]: 'Anual'
}

export enum ECertificationType {
	TOTAL = 79,
	PARCIAL = 80
}

export const CTipoCertificacion: Record<ECertificationType, string> = {
	[ECertificationType.TOTAL]: 'TOTAL',
	[ECertificationType.PARCIAL]: 'PARCIAL'
}

export enum EEntidadFederativa {
	AGUASCALIENTES = '01',
	BAJA_CALIFORNIA = '02',
	BAJA_CALIFORNIA_SUR = '03',
	CAMPECHE = '04',
	COAHUILA_DE_ZARAGOZA = '05',
	COLIMA = '06',
	CHIAPAS = '07',
	CHIHUAHUA = '08',
	CIUDAD_DE_MEXICO = '09',
	DURANGO = '10',
	GUANAJUATO = '11',
	GUERRERO = '12',
	HIDALGO = '13',
	JALISCO = '14',
	MEXICO = '15',
	MICHOACAN_DE_OCAMPO = '16',
	MORELOS = '17',
	NAYARIT = '18',
	NUEVO_LEON = '19',
	OAXACA = '20',
	PUEBLA = '21',
	QUERETARO = '22',
	QUINTANA_ROO = '23',
	SAN_LUIS_POTOSI = '24',
	SINALOA = '25',
	SONORA = '26',
	TABASCO = '27',
	TAMAULIPAS = '28',
	TLAXCALA = '29',
	VERACRUZ_DE_IGNACIO_DE_LA_LLAVE = '30',
	YUCATAN = '31',
	ZACATECAS = '32',
	EXTRANJERO = '33'
}

export const NOMBRE_ENTIDAD_FEDERATIVA: Record<EEntidadFederativa, string> = {
	[EEntidadFederativa.AGUASCALIENTES]: 'AGUASCALIENTES',
	[EEntidadFederativa.BAJA_CALIFORNIA]: 'BAJA CALIFORNIA',
	[EEntidadFederativa.BAJA_CALIFORNIA_SUR]: 'BAJA CALIFORNIA SUR',
	[EEntidadFederativa.CAMPECHE]: 'CAMPECHE',
	[EEntidadFederativa.COAHUILA_DE_ZARAGOZA]: 'COAHUILA DE ZARAGOZA',
	[EEntidadFederativa.COLIMA]: 'COLIMA',
	[EEntidadFederativa.CHIAPAS]: 'CHIAPAS',
	[EEntidadFederativa.CHIHUAHUA]: 'CHIHUAHUA',
	[EEntidadFederativa.CIUDAD_DE_MEXICO]: 'CIUDAD DE MÉXICO',
	[EEntidadFederativa.DURANGO]: 'DURANGO',
	[EEntidadFederativa.GUANAJUATO]: 'GUANAJUATO',
	[EEntidadFederativa.GUERRERO]: 'GUERRERO',
	[EEntidadFederativa.HIDALGO]: 'HIDALGO',
	[EEntidadFederativa.JALISCO]: 'JALISCO',
	[EEntidadFederativa.MEXICO]: 'MÉXICO',
	[EEntidadFederativa.MICHOACAN_DE_OCAMPO]: 'MICHOACÁN DE OCAMPO',
	[EEntidadFederativa.MORELOS]: 'MORELOS',
	[EEntidadFederativa.NAYARIT]: 'NAYARIT',
	[EEntidadFederativa.NUEVO_LEON]: 'NUEVO LEÓN',
	[EEntidadFederativa.OAXACA]: 'OAXACA',
	[EEntidadFederativa.PUEBLA]: 'PUEBLA',
	[EEntidadFederativa.QUERETARO]: 'QUERÉTARO',
	[EEntidadFederativa.QUINTANA_ROO]: 'QUINTANA ROO',
	[EEntidadFederativa.SAN_LUIS_POTOSI]: 'SAN LUIS POTOSÍ',
	[EEntidadFederativa.SINALOA]: 'SINALOA',
	[EEntidadFederativa.SONORA]: 'SONORA',
	[EEntidadFederativa.TABASCO]: 'TABASCO',
	[EEntidadFederativa.TAMAULIPAS]: 'TAMAULIPAS',
	[EEntidadFederativa.TLAXCALA]: 'TLAXCALA',
	[EEntidadFederativa.VERACRUZ_DE_IGNACIO_DE_LA_LLAVE]: 'VERACRUZ DE IGNACIO DE LA LLAVE',
	[EEntidadFederativa.YUCATAN]: 'YUCATÁN',
	[EEntidadFederativa.ZACATECAS]: 'ZACATECAS',
	[EEntidadFederativa.EXTRANJERO]: 'EXTRANJERO'
}

export enum ETipoAsignatura {
	OBLIGATORIA = 263,
	OPTATIVA = 264,
	ADICIONAL = 265,
	COMPLEMENTARIA = 266
}

export enum EObservacionAsignatura {
	EQUIVALENCIA_ESTUDIOS = 70,
	EXAMEN_EXTRAORDINARIO = 71,
	EXAMEN_TITULO_SUFI = 72,
	CURSO_VERANO = 73,
	RECURSAMIENTO = 74,
	REINGRESO = 75,
	ACUERDO_REGULARIZACION = 76,
	CAMBIO_RVOE = 77,
	REVALIDACION_ESTUDIOS = 78,
	NORMAL_ORDINARIO = 100,
	CORRESPONDENCIA_PLAN = 101,
	EXENTO = 102,
	CURSO_REGULARIZACION = 104,
	INTERCAMBIO_ACADEMICO = 105,
	EXAMEN_ULTIMA_MATERIA = 106,
	CURSO_INVIERNO = 107
}

export const OBSERVACION_ASIGNATURA_DESCRIPCION: Record<EObservacionAsignatura, string> = {
	[EObservacionAsignatura.EQUIVALENCIA_ESTUDIOS]: 'EQUIVALENCIA DE ESTUDIOS',
	[EObservacionAsignatura.EXAMEN_EXTRAORDINARIO]: 'EXAMEN EXTRAORDINARIO',
	[EObservacionAsignatura.EXAMEN_TITULO_SUFI]: 'EXAMEN A TITULO DE SUFICIENCIA',
	[EObservacionAsignatura.CURSO_VERANO]: 'CURSO DE VERANO',
	[EObservacionAsignatura.RECURSAMIENTO]: 'RECURSAMIENTO',
	[EObservacionAsignatura.REINGRESO]: 'REINGRESO',
	[EObservacionAsignatura.ACUERDO_REGULARIZACION]: 'ACUERDO REGULARIZACIÓN',
	[EObservacionAsignatura.CAMBIO_RVOE]: 'CON CAMBIO EN EL ACUERDO DE RVOE',
	[EObservacionAsignatura.REVALIDACION_ESTUDIOS]: 'REVALIDACIÓN DE ESTUDIOS',
	[EObservacionAsignatura.NORMAL_ORDINARIO]: 'NORMAL / ORDINARIO',
	[EObservacionAsignatura.CORRESPONDENCIA_PLAN]: 'CORRESPONDENCIA DE ASIGNATURA POR PLAN',
	[EObservacionAsignatura.EXENTO]: 'EXENTO',
	[EObservacionAsignatura.CURSO_REGULARIZACION]: 'CURSO DE REGULARIZACIÓN',
	[EObservacionAsignatura.INTERCAMBIO_ACADEMICO]: 'INTERCAMBIO ACADÉMICO',
	[EObservacionAsignatura.EXAMEN_ULTIMA_MATERIA]: 'EXAMEN DE ÚLTIMA MATERIA',
	[EObservacionAsignatura.CURSO_INVIERNO]: 'CURSO DE INVIERNO'
}

export enum ECargo {
	DIRECTOR = 1,
	SUBDIRECTOR = 2,
	RECTOR = 3,
	VICERRECTOR = 4,
	RESPONSABLE_DE_EXPEDICION = 5,
	SECRETARIO_GENERAL = 6,
	AUTORIDAD_LOCAL = 7,
	AUTORIDAD_FEDERAL = 8,
	DIRECTOR_GENERAL = 9
}

export const NOMBRE_CARGO: Record<ECargo, string> = {
	[ECargo.DIRECTOR]: 'DIRECTOR',
	[ECargo.SUBDIRECTOR]: 'SUBDIRECTOR',
	[ECargo.RECTOR]: 'RECTOR',
	[ECargo.VICERRECTOR]: 'VICERRECTOR',
	[ECargo.RESPONSABLE_DE_EXPEDICION]: 'RESPONSABLE DE EXPEDICIÓN',
	[ECargo.SECRETARIO_GENERAL]: 'SECRETARIO GENERAL',
	[ECargo.AUTORIDAD_LOCAL]: 'AUTORIDAD LOCAL',
	[ECargo.AUTORIDAD_FEDERAL]: 'AUTORIDAD FEDERAL',
	[ECargo.DIRECTOR_GENERAL]: 'DIRECTOR GENERAL'
}

export enum ETipoEstudioAntecedente {
	MAESTRIA = '1',
	LICENCIATURA = '2',
	TECNICO_SUPERIOR_UNIVERSITARIO = '3',
	BACHILLERATO = '4',
	EQUIVALENTE_A_BACHILLERATO = '5',
	SECUNDARIA = '6'
}

export const NOMBRE_TIPO_ESTUDIO_ANTECEDENTE: Record<ETipoEstudioAntecedente, string> = {
	[ETipoEstudioAntecedente.MAESTRIA]: 'MAESTRÍA',
	[ETipoEstudioAntecedente.LICENCIATURA]: 'LICENCIATURA',
	[ETipoEstudioAntecedente.TECNICO_SUPERIOR_UNIVERSITARIO]: 'TÉCNICO SUPERIOR UNIVERSITARIO',
	[ETipoEstudioAntecedente.BACHILLERATO]: 'BACHILLERATO',
	[ETipoEstudioAntecedente.EQUIVALENTE_A_BACHILLERATO]: 'EQUIVALENTE A BACHILLERATO',
	[ETipoEstudioAntecedente.SECUNDARIA]: 'SECUNDARIA'
}

export enum EFundamentoServicioSocial {
	ART_52_LR_ART_5_CONST = 1,
	ART_55_LR_ART_5_CONST = 2,
	ART_91_RLR_ART_5_CONST = 3,
	ART_10_REGLAMENTO = 4,
	NO_APLICA = 5
}

export const NOMBRE_FUNDAMENTO_SERVICIO_SOCIAL: Record<EFundamentoServicioSocial, string> = {
	[EFundamentoServicioSocial.ART_52_LR_ART_5_CONST]: 'ART. 52 LRART. 5 CONST',
	[EFundamentoServicioSocial.ART_55_LR_ART_5_CONST]: 'ART. 55 LRART. 5 CONST',
	[EFundamentoServicioSocial.ART_91_RLR_ART_5_CONST]: 'ART. 91 RLRART. 5 CONST',
	[EFundamentoServicioSocial.ART_10_REGLAMENTO]: 'ART. 10 REGLAMENTO PARA LA PRESTACIÓN DEL SERVICIO SOCIAL DE LOS ESTUDIANTES DE LAS INSTITUCIONES DE EDUCACIÓN SUPERIOR EN LA REPÚBLICA MEXICANA',
	[EFundamentoServicioSocial.NO_APLICA]: 'NO APLICA'
}

export enum ENivelEstudio {
	DOCTORADO = 95,
	ESPECIALIDAD = 85,
	TECNICO_SUPERIOR_UNIVERSITARIO = 84,
	PROFESIONAL_ASOCIADO = 83,
	MAESTRIA = 82,
	LICENCIATURA = 81
}
export const NOMBRE_NIVEL_ESTUDIO: Record<ENivelEstudio, string> = {
	[ENivelEstudio.DOCTORADO]: 'DOCTORADO',
	[ENivelEstudio.ESPECIALIDAD]: 'ESPECIALIDAD',
	[ENivelEstudio.TECNICO_SUPERIOR_UNIVERSITARIO]: 'TÉCNICO SUPERIOR UNIVERSITARIO',
	[ENivelEstudio.PROFESIONAL_ASOCIADO]: 'PROFESIONAL ASOCIADO',
	[ENivelEstudio.MAESTRIA]: 'MAESTRÍA',
	[ENivelEstudio.LICENCIATURA]: 'LICENCIATURA'
}
export enum EStatusNotification {
	UNREAD = 'UNREAD',
	READ = 'READ'
}
export const CStatusNotification: Record<EStatusNotification, string> = {
	[EStatusNotification.UNREAD]: 'No leída',
	[EStatusNotification.READ]: 'Leída'
}
export enum ETipoCarrera {
	ESCOLARIZADA = 'ESCOLARIZADA',
	ABIERTA = 'ABIERTA',
	VIRTUAL = 'VIRTUAL',
	A_DISTANCIA = 'A_DISTANCIA',
	SEMIESCOLARIZADA = 'SEMIESCOLARIZADA',
	MIXTA = 'MIXTA',
	ACUERDO_SECRETARIAL = 'ACUERDO_SECRETARIAL',
	ESCOLARIZADA_ESTATAL = 'ESCOLARIZADA_ESTATAL',
	ABIERTA_ESTATAL = 'ABIERTA_ESTATAL',
	VIRTUAL_ESTATAL = 'VIRTUAL_ESTATAL',
	A_DISTANCIA_ESTATAL = 'A_DISTANCIA_ESTATAL',
	SEMIESCOLARIZADA_ESTATAL = 'SEMIESCOLARIZADA_ESTATAL',
	MIXTA_ESTATAL = 'MIXTA_ESTATAL',
	NO_ESCOLARIZADA = 'NO_ESCOLARIZADA'
}

export const NOMBRE_TIPO_CARRERA: Record<ETipoCarrera, string> = {
	[ETipoCarrera.ESCOLARIZADA]: 'Escolarizada',
	[ETipoCarrera.ABIERTA]: 'Abierta',
	[ETipoCarrera.VIRTUAL]: 'Virtual',
	[ETipoCarrera.A_DISTANCIA]: 'A Distancia',
	[ETipoCarrera.SEMIESCOLARIZADA]: 'Semi-Escolarizada',
	[ETipoCarrera.MIXTA]: 'Mixta',
	[ETipoCarrera.ACUERDO_SECRETARIAL]: 'Acuerdo Secretarial',
	[ETipoCarrera.ESCOLARIZADA_ESTATAL]: 'Escolarizada Estatal',
	[ETipoCarrera.ABIERTA_ESTATAL]: 'Abierta Estatal',
	[ETipoCarrera.VIRTUAL_ESTATAL]: 'Virtual Estatal',
	[ETipoCarrera.A_DISTANCIA_ESTATAL]: 'A Distancia Estatal',
	[ETipoCarrera.SEMIESCOLARIZADA_ESTATAL]: 'Semi-Escolarizada Estatal',
	[ETipoCarrera.MIXTA_ESTATAL]: 'Mixta Estatal',
	[ETipoCarrera.NO_ESCOLARIZADA]: 'No Escolarizada'
}

export enum EUserRole {
	ADMINISTRADOR = 'ADMINISTRADOR',
	USER = 'USER'
}
export enum EPlan {
	POSTPAID = 'postpaid',
	PREPAID = 'prepaid',
	UNLIMITED = 'unlimited',
	BASIC = 'basic'
}
export const PLAN_OPTIONS: { value: EPlan; text: string }[] = [
	{ value: EPlan.POSTPAID, text: 'Postpago' },
	{ value: EPlan.PREPAID, text: 'Prepago' },
	{ value: EPlan.UNLIMITED, text: 'Ilimitado (Plus)' },
	{ value: EPlan.BASIC, text: 'Ilimitado (Básico)' }
]
export enum ENivelCarrera {
	ING = 'Ing',
	LIC = 'Lic',
	MTR = 'Mtr',
	DR = 'Dr'
}
export const CNivelCarrera: { value: ENivelCarrera; text: string }[] = [
	{ value: ENivelCarrera.ING, text: 'Ingeniería' },
	{ value: ENivelCarrera.LIC, text: 'Licenciatura' },
	{ value: ENivelCarrera.MTR, text: 'Maestría' },
	{ value: ENivelCarrera.DR, text: 'Doctorado' }
]

export enum ETipoMantenimientoType {
	INFO = 'INFO',
	WARNING = 'WARNING',
	ERROR = 'ERROR',
	MAINTENANCE = 'MAINTENANCE'
}
export const NOMBRE_TIPO_MANTENIMIENTO: Record<ETipoMantenimientoType, string> = {
	[ETipoMantenimientoType.INFO]: 'INFORMATIVO',
	[ETipoMantenimientoType.WARNING]: 'ADVERTENCIA',
	[ETipoMantenimientoType.ERROR]: 'ERROR',
	[ETipoMantenimientoType.MAINTENANCE]: 'MANTENIMIENTO'
}
export enum ETipoError {
	PERMISSION_DENIED = 'PERMISSION_DENIED',
	UNAUTHENTICATED = 'UNAUTHENTICATED'
}
export enum EStatusFactura {
	PENDIENTE = 'PENDIENTE',
	PAGADA = 'PAGADA',
	CANCELADA = 'CANCELADA'
}
export enum EEstatusDocumento {
	CERTIFICADO_ESTUDIOS = 'Certificado de estudios',
	TITULO_PROFESIONAL = 'Título'
}
export enum ETipoDocumento {
	CERTIFICADO_TOTAL = 'Certificado total',
	CERTIFICADO_PARCIAL = 'Certificado parcial',
	TITULO_PROFESIONAL = 'Título profesional', //81
	DIPLOMA = 'Diploma', //82
	GRADO = 'Grado' //84,95
}
